import { DataService } from './dataService'
const domesticTariffServices = {
	add_domestic_tariff: async (data) => {
		return DataService.post('/admin/add_domestic_tariff', data)
	},

	update_domestic_tariff: async (data) => {
		return DataService.post('/admin/update_domestic_tariff' ,data)
	},

    update_domestic_tariff_status: async (data) => {
        return DataService.post('/admin/update_domestic_tariff_status' ,data)
    },

    get_domestic_tariff: async (data) => {
		return DataService.get('/admin/get_domestic_tariff', data)
	},

}

export default domesticTariffServices